import React, {useState} from 'react'
import {get} from "../../../../Model/Network/Config/Axios";
import {SearchableSelect} from "../../Class/Select/SearchableSelec2";


function SearchDepartment(props){
	let [allOffices,setOffices] =  useState([])

	return(
		<SearchableSelect label={props.title} placeholder={props.title}
						  select={props.onSelect}
						  disabled={props.disabled}
						  onChange={val => {
							  if (val.length > 1) {
								let data = {q:val};
								  get(`/search/searchDepartment`, (e, r) => {
									 setOffices(r.departments.map(val => ({
										 label: val.name,
										 value: val.id,
										 name:val.name,
										 des:val.office?val.office:undefined,

									 })))
								  }, data)

							  }
						  }}
						  items={allOffices}
						  style={{
							  color: '#e6ebf3',
							  height: 46,
							  marginBottom: 12
						  }}
		/>
	)
}
export {
	SearchDepartment
}
